import styled from 'styled-components';
import { useCriarUsuario } from '../../../Hooks/Usuario/useCriarUsuario';
import { useState, useEffect } from 'react';

const CardCadastro = ({ onSwitch }) => {

  const {criar, loading, erro, sucesso, dadosRecebidos } = useCriarUsuario();
  const [form, setForm] = useState({nomeCompleto: "", email: "", cpf: "", celular: "", senha: ""});

  const handleChange = (e) => {
    setForm({...form, [e.target.name]: e.target.value});
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    await criar(form);
  };

  useEffect(() => {
    if (sucesso) {
      alert("Usuário criado com sucesso!!");
      setForm({ nomeCompleto: "", email: "", cpf: "", celular: "", senha: "" });
      onSwitch();
    }
  }, [sucesso]);

  useEffect(() => {
    if (erro) {
      alert("Erro ao criar usuário: " + erro);
    }
  }, [erro]);


  return (
    <StyledWrapper>
      <div className="form-container">
        <p className="title">Cadastro</p>
        <form className="form" onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="nome">Nome Completo</label>
            <input type="text" name="nomeCompleto" id="nome" onChange={handleChange} value={form.nomeCompleto} required/>
          </div>
          <div className="input-group">
            <label htmlFor="email">Email</label>
            <input type="email" name="email" id="email" onChange={handleChange} value={form.email} required/>
          </div>
          <div className="input-group">
            <label htmlFor="cpf">CPF</label>
            <input type="text" name="cpf" id="cpf" onChange={handleChange} value={form.cpf} required/>
          </div>
          <div className="input-group">
            <label htmlFor="celular">Celular</label>
            <input type="tel" name="celular" id="celular" onChange={handleChange} value={form.celular} required/>
          </div>
          <div className="input-group">
            <label htmlFor="senha">Senha</label>
            <input type="password" name="senha" id="senha" onChange={handleChange} value={form.senha} required/>
          </div>
          <button className="sign" disabled={loading}>Cadastrar</button>
        </form>
        <p className="signup">
          Já tem conta?
          <a href="#" onClick={e => { e.preventDefault(); onSwitch(); }}> Entrar</a>
        </p>
      </div>
    </StyledWrapper>
  )
};

const StyledWrapper = styled.div`
  .form-container {
    width: 100%;
    border-radius: 0.75rem;
    background-color: #111827;
    padding: 2rem;
    color: rgba(243, 244, 246, 1);
  }
  .title {
    text-align: center;
    font-size: 1.5rem;
    line-height: 2rem;
    font-weight: 700;
  }
  .form {
    margin-top: 1.5rem;
  }
  .input-group {
    margin-top: 0.25rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .input-group label {
    display: block;
    color: rgba(156, 163, 175, 1);
    margin-bottom: 4px;
  }
  .input-group input {
    width: 100%;
    border-radius: 0.375rem;
    border: 1px solid rgba(55, 65, 81, 1);
    outline: 0;
    background-color: rgba(17, 24, 39, 1);
    padding: 0.75rem 1rem;
    color: rgba(243, 244, 246, 1);
  }
  .input-group input:focus {
    border-color: rgba(167, 139, 250);
  }
  .sign {
    display: block;
    width: 100%;
    background-color: #623bda;
    padding: 0.75rem;
    text-align: center;
    color: whitesmoke;
    border: none;
    border-radius: 0.375rem;
    font-weight: 600;
    margin-top: 1rem;
  }
  .signup {
    text-align: center;
    font-size: 0.75rem;
    line-height: 1rem;
    color: rgba(156, 163, 175, 1);
    margin-top: 1rem;
  }
  .signup a {
    color: rgba(243, 244, 246, 1);
    text-decoration: none;
    font-size: 14px;
  }
  .signup a:hover {
    text-decoration: underline #a78bfa;
  }
`;

export default CardCadastro;